<template>
  <div class="columns">
    <div class="column is-4">
      <b-field>
        <b-input
          v-model="busquedaArticulo"
          icon="search"
          placeholder="Buscar artículo"
        />
      </b-field>
    </div>
    <div class="column is-4">
      <b-field>
        <b-input
          v-model="busquedaFolio"
          icon="search"
          placeholder="Buscar usuario y/o folio"
        />
      </b-field>
    </div>
    <div class="column is-1">
      <b-field>
        <b-select
          v-model="metadata.pageSize"
          icon="file"
          placeholder="Tam. Pág."
          expanded
          @input="changePageSizeHandle"
        >
          <option v-for="item in metadata.pageSizes" :key="item" :value="item">
            {{ item }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-3">
      <b-pagination
        v-model="metadata.page"
        :total="metadata.totalItems"
        range-before="1"
        range-after="1"
        :simple="false"
        :rounded="false"
        :per-page="metadata.pageSize"
        icon-prev="chevron-left"
        icon-next="chevron-right"
        aria-next-label="Siguiente página"
        aria-previous-label="Página anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
        :page-input="true"
        :page-input-position="inputPosition"
        :debounce-page-input="inputDebounce"
        @change="changePageHandle"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      inputPosition: '',
      inputDebounce: '',
      busquedaArticulo: '',
      busquedaFolio: ''
    }
  },
  computed: {
    ...mapGetters('comparador', ['metadata'])
  },
  watch: {
    busquedaArticulo: debounce(function (newVal) {
      this.changeBusquedaArticuloHandle(newVal)
    }, 300),
    busquedaFolio: debounce(function (newVal) {
      this.changeBusquedaFolioHandle(newVal)
    }, 300)
  },
  methods: {
    changePageHandle(page) {
      this.$store.dispatch('comparador/setComparadorPage', {
        page
      })
    },
    changePageSizeHandle(pageSize) {
      this.$store.dispatch('comparador/setPageSize', {
        pageSize
      })
    },
    async changeBusquedaArticuloHandle(busqueda) {
      this.$store.dispatch('comparador/setBusqueda', {
        busquedaArticulo: busqueda,
        busquedaFolio: null
      })
    },
    changeBusquedaFolioHandle(busqueda) {
      this.$store.dispatch('comparador/setBusqueda', {
        busquedaArticulo: null,
        busquedaFolio: busqueda
      })
    }
  }
}

export function debounce(fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
</script>
